import React from 'react';
import moment from 'moment';
// react plugin for creating charts
import ChartistGraph from 'react-chartist';
import Chartist from 'chartist';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import chartsStyle from 'assets/jss/material-dashboard-pro-react/views/chartsStyle.jsx';
// @material-ui/icons
import Timeline from '@material-ui/icons/Timeline';
// core components

import Card from 'components/Card/Card.jsx';
import CardHeader from 'components/Card/CardHeader.jsx';
import CardIcon from 'components/Card/CardIcon.jsx';
import CardBody from 'components/Card/CardBody.jsx';

const TicketsGraph = ({ ticketCountPerDay, classes }) => {
  if (!ticketCountPerDay.length) {
    return null;
  }
  // const graphDAta = ticketCountPerDay.reduce(())
  const labelsModulo = Math.max(Math.round(ticketCountPerDay.length / 8), 1);
  const graphData = ticketCountPerDay.reduce(
    (data, countPerDay, index) => {
      const ticketCount = countPerDay.count;
      data.series[0].push(ticketCount);
      if (index % labelsModulo === 0) {
        data.labels.push(moment(countPerDay.date).format('DD.MM'));
      } else {
        data.labels.push('');
      }
      return data;
    },
    { series: [[]], labels: [] }
  );

  const graphOptions = {
    lineSmooth: Chartist.Interpolation.cardinal({
      tension: 10,
    }),
    axisY: {
      showGrid: true,
      offset: 60,
    },
    axisX: {
      showGrid: false,
    },
    low: 0,
    high: Math.max(...graphData.series[0]) + 50,
    showPoint: false,
    height: '300px',
  };

  return (
    <Card>
      <CardHeader color="info" icon>
        <CardIcon color="info">
          <Timeline />
        </CardIcon>
        <h4 className={classes.cardIconTitle}>Verkaufte Tickets pro Tag</h4>
      </CardHeader>
      <CardBody>
        <ChartistGraph data={graphData} type="Bar" options={graphOptions} />
      </CardBody>
    </Card>
  );
};

TicketsGraph.defaultProps = {
  ticketCountPerDay: {},
};

export default withStyles(chartsStyle)(TicketsGraph);



// WEBPACK FOOTER //
// ./src/views/reports/components/TicketsGraph.jsx